<template>
  <div class="page-feedback page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="24">
          <h3 style="float: none;">意见反馈</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>客户管理</el-breadcrumb-item>
              <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block content-body">
          <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
            <el-form-item prop="userName" label="反馈人：" style="margin-bottom: 0;">
              <el-input v-model="form_search.userName" size="small" placeholder="请输入反馈人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item prop="ctype" label="反馈分类：" style="margin-bottom: 0;">
              <el-select v-model="form_search.ctype" size="small" placeholder="请选择反馈分类" clearable>
                <el-option label="意见" value="意见"></el-option>
                <el-option label="建议" value="建议"></el-option>
                <el-option label="投诉" value="投诉"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="hasRecover" label="回复状态：" style="margin-bottom: 0;">
              <el-select v-model="form_search.hasRecover" size="small" placeholder="请选择回复状态" clearable>
                <el-option label="未回复" :value="0"></el-option>
                <el-option label="已回复" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
              <el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
<!--              <el-table-column prop="icode" align="center" label="编号" min-width="180"></el-table-column>-->
              <el-table-column prop="ctype" align="center" label="反馈分类" min-width="100"></el-table-column>
              <el-table-column prop="userName" align="center" label="反馈人" min-width="120"></el-table-column>
              <el-table-column prop="remark" align="left" label="反馈内容" min-width="250" show-overflow-tooltip></el-table-column>
              <el-table-column prop="imgIds" align="center" label="图片" min-width="150">
                <template slot-scope="scope">
                  <div class="img-list" v-if="scope.row.imgIds">
                    <img v-for="(imgId, index) in (scope.row.imgIds || '').split(',').filter(id => id)"
                         :key="index"
                         class="cursor img-item"
                         :src="baseUrl+'/api/sys/file/download?attachId=' + imgId.trim() +'&width=300'"
                         height="50"
                         @click="previewImages(scope.row.imgIds, index)"
                         title="点击查看" />
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="hasRecover" align="center" label="回复状态" min-width="100">
                <template slot-scope="scope">
                  <span :class="{'status-unreplied': scope.row.hasRecover === 0, 'status-replied': scope.row.hasRecover === 1}">
                    {{ scope.row.hasRecover === 1 ? '已回复' : '未回复' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="recoverTxt" align="left" label="回复内容" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.recoverTxt || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="recoverUser" align="center" label="回复人" min-width="120">
                <template slot-scope="scope">
                  {{ scope.row.recoverUser || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="recoverDate" align="center" label="回复时间" min-width="160">
                <template slot-scope="scope">
                  {{ scope.row.recoverDate || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
              <el-table-column align="center" label="操作" min-width="200" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="openReplyDialog(scope.row)">
                    {{ scope.row.hasRecover === 1 ? '重新回复' : '回复' }}
                  </el-button>
                  <el-button size="small" type="danger" @click="deleteFeedback(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
                         :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
                         :total="table_data.page_info.total">
          </el-pagination>
        </div>

        <!-- 图片预览弹窗 -->
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="600px">
          <div class="preview-container">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
            <div class="preview-nav" v-if="dlg_preview.images.length > 1">
              <el-button @click="prevImage" :disabled="dlg_preview.current === 0" size="small">上一张</el-button>
              <span>{{ dlg_preview.current + 1 }} / {{ dlg_preview.images.length }}</span>
              <el-button @click="nextImage" :disabled="dlg_preview.current === dlg_preview.images.length - 1" size="small">下一张</el-button>
            </div>
          </div>
        </el-dialog>

        <!-- 回复弹窗 -->
        <el-dialog :visible.sync="dlg_reply.visible" title="回复反馈" width="600px">
          <el-form :model="dlg_reply.form" label-width="100px">
            <el-form-item label="反馈编号：">
              <span>{{ dlg_reply.form.icode }}</span>
            </el-form-item>
            <el-form-item label="反馈分类：">
              <span>{{ dlg_reply.form.ctype }}</span>
            </el-form-item>
            <el-form-item label="反馈人：">
              <span>{{ dlg_reply.form.userName }}</span>
            </el-form-item>
            <el-form-item label="反馈内容：">
              <div>{{ dlg_reply.form.remark }}</div>
            </el-form-item>
            <el-form-item label="回复内容：" required>
              <el-input type="textarea" v-model="dlg_reply.form.recoverTxt" :rows="5" placeholder="请输入回复内容"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dlg_reply.visible = false">取消</el-button>
            <el-button type="primary" @click="submitReply" :loading="dlg_reply.loading">提交回复</el-button>
          </div>
        </el-dialog>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feedbackManage',
  data() {
    return {
      clientHeight: '',
      baseUrl: this.$client.API_URL,
      body_loading: false,
      form_search: {
        userName: '',
        ctype: '',
        hasRecover: ''
      },
      table_data: {
        loading: false,
        list: [],
        page_info: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      },
      dlg_preview: {
        visible: false,
        img_url: '',
        images: [],
        current: 0
      },
      dlg_reply: {
        visible: false,
        loading: false,
        form: {
          icode: '',
          ctype: '',
          userName: '',
          remark: '',
          recoverTxt: ''
        }
      }
    }
  },
  created() {
    document.title = '意见反馈';
    this.getList();
  },
  methods: {
    searchList() {
      this.table_data.page_info.page = 1;
      this.getList();
    },
    getList() {
      var _this = this;
      var params = {
        pageNo: _this.table_data.page_info.page,
        pageSize: _this.table_data.page_info.pageSize
      };

      // 添加搜索条件
      if (_this.form_search.userName) {
        params.userName = _this.form_search.userName;
      }
      if (_this.form_search.ctype) {
        params.ctype = _this.form_search.ctype;
      }
      if (_this.form_search.hasRecover !== '') {
        params.hasRecover = _this.form_search.hasRecover;
      }

      _this.table_data.loading = true;
      this.$client.get('/api/sys/feedback/getListForAdmin', params, function(res, message, total, totalPages) {
        _this.table_data.list = res || [];
        _this.table_data.page_info.total = total || 0;
        _this.table_data.loading = false;
      }, function(res) {
        _this.table_data.loading = false;
      });
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    changeFixed(clientHeight) {
      this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
    },
    previewImages(imgIds, index) {
      const ids = (imgIds || '').split(',').filter(id => id).map(id => id.trim());
      this.dlg_preview.images = ids;
      this.dlg_preview.current = index;
      this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + ids[index] + '&width=800';
      this.dlg_preview.visible = true;
    },
    prevImage() {
      if (this.dlg_preview.current > 0) {
        this.dlg_preview.current--;
        this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + this.dlg_preview.images[this.dlg_preview.current] + '&width=800';
      }
    },
    nextImage() {
      if (this.dlg_preview.current < this.dlg_preview.images.length - 1) {
        this.dlg_preview.current++;
        this.dlg_preview.img_url = this.baseUrl + '/api/sys/file/download?attachId=' + this.dlg_preview.images[this.dlg_preview.current] + '&width=800';
      }
    },
    openReplyDialog(row) {
      this.dlg_reply.form = {
        icode: row.icode,
        ctype: row.ctype,
        userName: row.userName,
        remark: row.remark,
        recoverTxt: row.recoverTxt || ''
      };
      this.dlg_reply.visible = true;
    },
    deleteFeedback(row) {
      var _this = this;
      this.$confirm('确认删除该反馈记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          id: row.icode
        };
        _this.$client.post('/api/sys/feedback/delete', params, function(res, message) {
          _this.$message.success('删除成功');
          _this.getList();
        });
      }).catch(() => {});
    },
    submitReply() {
      var _this = this;

      if (!_this.dlg_reply.form.recoverTxt || !_this.dlg_reply.form.recoverTxt.trim()) {
        _this.$message.warning('请输入回复内容');
        return;
      }

      _this.dlg_reply.loading = true;
      var params = {
        icode: _this.dlg_reply.form.icode,
        recoverTxt: _this.dlg_reply.form.recoverTxt
      };

      this.$client.post('/api/sys/feedback/recover', params, function(res, message) {
        _this.$message.success('回复成功');
        _this.dlg_reply.visible = false;
        _this.dlg_reply.loading = false;
        _this.getList();
      }, function(res) {
        _this.dlg_reply.loading = false;
      });
    }
  },
  mounted() {
    this.clientHeight = `${document.documentElement.clientHeight}`;
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  }
}
</script>

<style>
.page-feedback .el-upload--picture-card {
  line-height: 80px;
}
.page-feedback .el-upload--picture-card, .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
</style>

<style scoped>
.img-list {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: center;
}
.img-item {
  object-fit: cover;
  border-radius: 4px;
}
.preview-container {
  text-align: center;
}
.preview-nav {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.status-unreplied {
  color: #E6A23C;
  font-weight: bold;
}
.status-replied {
  color: #67C23A;
  font-weight: bold;
}
</style>
